import { ApplicationConfig, enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, RouterModule, withPreloading } from '@angular/router';

import { APP_ROUTES } from './app.routes';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { PipesModule } from 'uPipes/pipes.module';
import {
  RECAPTCHA_SETTINGS,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaFormsModule,
  RecaptchaModule, RecaptchaSettings,
  RecaptchaV3Module
} from 'ng-recaptcha';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { CustomGestureConfigService } from 'uServices/custom-gesture-config.service';
import { SafePipe } from 'uPipes/safe.pipe';
import { environment } from 'uEnvironments/environment';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeUk from '@angular/common/locales/uk';
import localeRu from '@angular/common/locales/ru-UA';
import localeEn from '@angular/common/locales/en';
import { StorageService } from 'uServices/storage.service';


// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export class DynamicLocaleId extends String {
  constructor(protected service: TranslateService) {
    super('');
  }

  override toString() {
    return this.service.currentLang;
  }
}

registerLocaleData(localeUk, 'ua');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeEn, 'en');

if (environment.production) {
  enableProdMode();
  if (window) {
    try { (window as any).console.log = () => {}; } catch (e) {}
  }
}

export const appConfig: ApplicationConfig = {providers: [
    provideRouter([...APP_ROUTES], withPreloading(PreloadAllModules)),
    importProvidersFrom(
      CommonModule,
      IonicModule.forRoot({
        backButtonText: '' // Set an empty string to have no text next to the back icon
      }),
      IonicStorageModule.forRoot({
        name: '__mydb',
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
      }),
      PipesModule.forRoot(),
      RecaptchaFormsModule, RecaptchaModule, RecaptchaV3Module,
      RouterModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        }
      })),
    DatePipe,
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomGestureConfigService },
    HttpClient,
    StorageService,
    SafePipe,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKeyV3, deps: [environment] },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
      deps: [environment]
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useClass: DynamicLocaleId, deps: [TranslateService] },
    provideHttpClient(withInterceptorsFromDi())
  ]
};
